import { Fragment } from 'react';

import { RepresentativeForm, type IRepresentativeForm } from 'src/components/Escrow/Representative';
import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

import { useRepresentative } from '../model';

const EditRepresentative = () => {
  const { representatives, representativeId, setInitialData, submit, agreementType, role } = useRepresentative();

  const representativeData = representatives.find((rep) => rep.id === representativeId);

  if (!representativeData) return null;

  const onSubmit = async (values: IRepresentativeForm) => {
    await submit?.edit(representativeId ?? '', values);
    setInitialData();
  };

  const initialValues = {
    name: representativeData?.name ?? '',
    email: representativeData?.email ?? '',
    phone: representativeData?.phone ?? '',
    signatory: representativeData?.signatory ?? false,
  };
  const showSignatory =
    agreementType === AgreementFormEnum.Tripartite ||
    (agreementType === AgreementFormEnum.Bipartite && role === EscrowPartyTypeEnum.Depositor);

  return (
    <Fragment>
      <DialogHeader>
        <DialogTitle className="text-base font-bold">Edit representative</DialogTitle>
        <DialogDescription className="sr-only">Edit Representative</DialogDescription>
      </DialogHeader>
      <RepresentativeForm
        onCancel={setInitialData}
        onSubmit={onSubmit}
        initialValues={initialValues}
        withSignatory={showSignatory}
      />
    </Fragment>
  );
};

export default EditRepresentative;
